import React, { useState } from "react";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../../../component/page/loading/spinner";
import docAid from "../../../assets/doc-aid.png";

// Helper to get all users (default + stored)
const getAllUsers = () => {
  const defaultUsers = [
    { email: "admin@gmail.com", password: "123456", role: "admin" },
    { email: "doctor@gmail.com", password: "123456", role: "doctor" },
    { email: "patient@gmail.com", password: "123456", role: "patient" },
  ];
  const stored = JSON.parse(localStorage.getItem("users")) || [];
  // Stored users get priority (override default)
  return [...stored, ...defaultUsers.filter(u => !stored.some(s => s.email === u.email))];
};

const SendOtp = () => {
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Please enter email"),
    }),
    onSubmit: (values) => {
      handleSendOtp(values.email);
    },
  });

  const handleSendOtp = (email) => {
    setLoadingSpinner(true);

    // Check if email exists in users list
    const users = getAllUsers();
    const userExists = users.some((u) => u.email === email);

    if (!userExists) {
      toast.error("This email is not registered. Please sign up.");
      setLoadingSpinner(false);
      return;
    }

    // Generate OTP
    const otp = Math.floor(1000 + Math.random() * 9000);

    // Store OTP in localStorage
    localStorage.setItem(
      "userOTP",
      JSON.stringify({
        email: email,
        otp: otp,
        timestamp: Date.now(),
      })
    );

    toast.success(`OTP sent to ${email} (Demo: ${otp})`);
    setLoadingSpinner(false);

    // Navigate to OTP validation page
    navigate("/forgotValidateOTP", { state: { getEmail: email } });
  };

  return (
    <>
      <div className="min-h-screen bg-gray-100 text-gray-900 flex flex-col items-center justify-between">
        <div className="max-w-screen-xl m-0 sm:m-10 md:shadow sm:rounded-lg flex justify-center flex-1">
          <div className="lg:flex-1 md:bg-white text-center flex flex-col justify-center items-center">
            <div className="w-full flex justify-center items-center">
              <div className="lg:w-3/4 mb-24 md:mb-0">
                <img
                  alt="img"
                  className="w-[350px] xl:w-full lg:w-auto mb-24 md:mb-0"
                  src={docAid}
                />
              </div>
            </div>
          </div>
          {/* Single Form – responsive */}
          <div
            className="lg:w-1/2 xl:w-5/12 p-6 sm:p-12 flex items-center"
            style={{ backgroundColor: "rgb(237, 231, 242)" }}
          >
            <form
              onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
              }}
              className="w-full"
            >
              <div className="mx-auto max-w-xs">
                <h2 className="text-2xl font-bold text-center mb-2">
                  Forgot Password
                </h2>
                <p className="text-center text-gray-600 mb-6">
                  Enter your registered email to receive OTP
                </p>

                <input
                  className="w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white"
                  type="email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Email"
                  autoComplete="email"
                />
                {formik.touched.email && formik.errors.email && (
                  <p className="text-red-500 text-sm mt-1">
                    {formik.errors.email}
                  </p>
                )}

                <button
                  type="submit"
                  disabled={loadingSpinner}
                  className="mt-5 tracking-wide font-semibold text-white w-full py-4 rounded-lg transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none disabled:opacity-50"
                  style={{ backgroundColor: "rgb(7, 160, 165)" }}
                >
                  {loadingSpinner ? "Sending..." : "Send OTP"}
                </button>

                <p className="mt-6 text-md text-gray-900 text-center">
                  Already have an Account?{" "}
                  <Link
                    to="/"
                    className="text-blue-500 font-semibold hover:underline"
                  >
                    Login
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
      {loadingSpinner && <Spinner />}
      <ToastContainer />
    </>
  );
};

export default SendOtp;